import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { TRANSFERTS_URL } from "../../settings/APISetting";
import api from "../../config/axiosConfig";

export const fetchTransfert = createAsyncThunk('fetch-transferts', async () => {
    const response = await api.get(TRANSFERTS_URL);
    return response.data;
});



const transfertSlice = createSlice({

    name: 'transferts',
    initialState: {transferts: {}, transfertsFetchStatus: '' },

    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchTransfert.fulfilled, (state, action) => {

            state.transferts =   action.payload;
   
            state.transfertsFetchStatus = 'success';
        }).addCase(fetchTransfert.pending, (state, action) => {
            state.transfertsFetchStatus = 'loading';

        }).addCase(fetchTransfert.rejected, (state, action) => {

            state.transfertsFetchStatus = 'error';

        });
    }


});
export default transfertSlice;